import { shape, string } from 'prop-types';

const ContributorPropType = shape({ email: string.isRequired, name: string.isRequired });

export default ContributorPropType;
